const keypurposes = {
  ASYMMETRIC_SIGN: 'Signing',
  ASYMMETRIC_DECRYPT: 'Decryption',
  AUTHENTICATE: 'Authenticate',
  SYMMETRIC_ENCRYPT: 'Symmetric encrypt'
}

export default keypurposes
